import { requireAuth } from "@/router/helpers";

/**
 * FE routes
 */
const FeRoutes = [];

/**
 * Admin routes
 */

const AdminRoutes = [
  {
    path: "/admin/banner",
    name: "AdminBannerIndex",
    component: () => import("./../pages/admin/Index"),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: "/admin/banner/report",
    name: "AdminBannerReport",
    component: () => import("./../pages/admin/Report"),
    beforeEnter: requireAuth,
    meta: {
      isAdmin: true,
    },
  },
  {
    path: "/admin/banner/create",
    name: "AdminBannerCreate",
    component: () => import("./../pages/admin/AddEditPage"),
    // components: {
    //   default: () => import("./../pages/admin/Index"),
    //   panel: () => import("./../pages/admin/AddEdit"),
    // },
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: "/admin/banner/edit/:id",
    name: "AdminBannerEdit",
    component: () => import("./../pages/admin/AddEditPage"),
    // components: {
    //   default: () => import("./../pages/admin/Index"),
    //   panel: () => import("./../pages/admin/AddEdit"),
    // },
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
  {
    path: "/admin/banner/preview",
    name: "AdminBannerPreview",
    component: () => import("./../pages/admin/Preview"),
    // components: {
    //   default: () => import("./../pages/admin/Index"),
    //   panel: () => import("./../pages/admin/AddEdit"),
    // },
    beforeEnter: requireAuth,
    meta: { isAdmin: true },
  },
];

export default [...FeRoutes, ...AdminRoutes];
